"use client";

import Link from "next/link";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import NotFoundLayout from "@/components/layouts/not-found-layout";
import { usePathname } from "next/navigation";

export default function NotFound() {
  const pathname = usePathname();
  const isGerman = pathname.startsWith("/de");
  const locale = isGerman ? "de" : "en";

  return (
    <NotFoundLayout locale={locale}>
      <div className="container flex flex-1 flex-col items-center justify-center gap-4 py-16">
        <h1 className="text-4xl font-bold">
          {isGerman ? "404 - Seite nicht gefunden" : "404 - Page Not Found"}
        </h1>
        <p className="text-muted-foreground">
          {isGerman
            ? "Die angeforderte Seite konnte nicht gefunden werden."
            : "The page you requested could not be found."}
        </p>
        <Link
          href={`/${locale}`}
          className={cn(buttonVariants({ variant: "default" }), "mt-4")}
        >
          {isGerman ? "Zurück zur Startseite" : "Back to Home"}
        </Link>
      </div>
    </NotFoundLayout>
  );
}
